import { getTimeString } from '../components/AppUtils';

function writeInitializerType (state) {
  if (state.settingForceWrite || state.settingSeamlessWrite) {
    return "warning"
  } else {
    return "info"
  }
}

function writeInitializerHeadline (state) {
  if (state.settingForceWrite || state.settingSeamlessWrite) {
    return "Warning"
  } else {
    return "Information"
  }
}

function writeInitializerSubHeadline (state) {
  if (state.settingForceWrite) {
    return "Froce write mode enabled"
  } else if (state.settingSeamlessWrite) {
    return "Seamless write mode enabled"
  } else {
    return  "Write mode enabled"
  }
}

function writeInitializerText (state, value) {
  if (state.settingForceWrite) {
    return "Data is written to every device without checking."
  } else if (state.settingSeamlessWrite) {
    return "Writing to other devices of the same type allowed."
  } else {
    return (value <= 0)? "Data will be written to scanned device.":`${value} change(s) will be written to device.`
  }
}


export const reducer = (state, action) => {
  let timeString = getTimeString();
  console.debug("Dispatch:", action.type, action.value ? action.value : "");
  switch (action.type) {
    case 'ndef/control/idle':
      return {
        ...state,
        ndefControl: 'idle',
      };
    case 'ndef/control/reading':
      return {
        ...state,
        ndefControl: 'reading',
      };
    case 'ndef/control/writing':
      return {
        ...state,
        ndefControl: 'writing',
      };
    case 'ndef/control/writeLock':
      return {
        ...state,
        writeLock: true,
      };
    case 'ndef/control/writeUnlock':
      return {
        ...state,
        writeLock: false,
      };
    case 'ndef/control/updateScanTime':
      return {
        ...state,
        nfcDataScanTime: timeString,
      };
    case 'ndef/control/setForNewRead':
      return {
        ...state,
        nfcSchema: {},
        nfcDataV: {"V": {}},
        nfcDataVP: {"VP": {}},
        nfcDataP: {"P": {}},
        nfcDataPR: {"PR": {}},
        nfcDataPP: {"PP": {}},
        originP: {"P": {}},
        originPR: {"PR": {}},
        originPP: {"PP": {}},
        nfcDataCP: {"CP": {}},
        nfcAvailable: true,
        nfcDataScanTime:"unknown"
      };
    case 'ndef/control/resetChanges':
      return {
        ...state,
        nfcDataP: state.originP,
        nfcDataPR: state.originPR,
        nfcDataPP: state.originPP,
      };
    case 'ndef/scan/write/done':
      return {
        ...state,
        originP: state.nfcDataP,
        originPR: state.nfcDataPR,
        originPP: state.nfcDataPP,
      };
    case 'ndef/scan/scanning':
      return {
        ...state,
        uiNdefState: 'scanning',
      };
    case 'ndef/scan/processing':
      return {
        ...state,
        uiNdefState: 'processing',
      };
    case 'ndef/scan/failed':
      return {
        ...state,
        uiNdefState: 'error',
      };
    case 'ndef/scan/done':
      return {
        ...state,
        uiNdefState: 'done',
        nfcDataScanTime: timeString,
      };
    case 'nfc/status/available':
      return {
        ...state,
        nfcAvailable: action.value,
      };
    case 'nfc/status/permission':
      return {
        ...state,
        nfcPermission: action.value,
      };
    case 'nfc/status/notAvailable':
      return {
        ...state,
        nfcAvailable: false,
      };
    case 'data/nfcTagSnUpdated':
      return {
        ...state,
        nfcTagSn: action.value,
        nfcDataSource: 'scan'
      };
    case 'app/originUrlUpdated':
      return { ...state, currentURL: action.value };
    case 'data/V/updated':
      return {
        ...state,
        nfcDataV: action.value
      };
    case 'data/VP/updated':
      return {
        ...state,
        nfcDataVP: action.value
      };
    case 'data/P/readOut':
      return {
        ...state,
        nfcDataP: action.value,
        originP: action.value
      };
    case 'data/PR/readOut':
      return {
        ...state,
        nfcDataPR: action.value,
        originPR: action.value
      };
    case 'data/PP/readOut':
      return { ...state, nfcDataPP: action.value, originPP: action.value };
    case 'data/P/updated':
      return {
        ...state,
        nfcDataP: action.value,
      };
    case 'data/PR/updated':
      return {
        ...state,
        nfcDataPR: action.value,
      };
    case 'data/PP/updated':
      return {
        ...state,
        nfcDataPP: action.value,
      };
    case 'data/CP/updated':
      return {
        ...state,
        nfcDataCP: action.value
      };
    case 'data/V/imported':
      return {
        ...state,
        nfcDataV: action.value,
        nfcDataSource: 'import'
      };
    case 'data/VP/imported':
      return {
        ...state,
        nfcDataVP: action.value,
        nfcDataSource: 'import'
      };
    case 'data/P/imported':
      return {
        ...state,
        nfcDataP: action.value,
        originP: action.value,
        nfcDataSource: 'import'
      };
    case 'data/PR/imported':
      return {
        ...state,
        nfcDataPR: action.value,
        originPR: action.value,
        nfcDataSource: 'import'
      };
    case 'data/PP/imported':
      return {
        ...state,
        nfcDataPP: action.value,
        originPP: action.value,
        nfcDataSource: 'import'
      };
    case 'data/CP/imported':
      return {
        ...state,
        nfcDataCP: action.value,
        nfcDataSource: 'import'
      };
    case 'data/checkTag/setStatus':
      return {
        ...state,
        checkTag: action.value
      };
    case 'data/checkTag/done':
      if (action.value.status === 'tagOkay') {
        switch(action.value.message) {
          case 'checkDataImported':
            return {
              ...state,
              nfcUri: action.value.nfcUri,
              nfcSchemaCompressed: action.value.nfcSchemaCompressed,
              nfcDataCP: action.value.nfcDataCP,
              nfcDataP: action.value.nfcDataP,
              originP: action.value.nfcDataP,
              nfcDataPP: action.value.nfcDataPP,
              originPP: action.value.nfcDataPP,
              nfcDataPR: action.value.nfcDataPR,
              originPR: action.value.nfcDataPR,
              nfcDataV: action.value.nfcDataV,
              nfcDataVP: action.value.nfcDataVP,
              checkTagResult: action.value,
              checkTag: 'done'
            };
          default:
            return {
              ...state,
              nfcUri: action.value.nfcUri,
              nfcSchemaCompressed: action.value.nfcSchemaCompressed,
              checkTagResult: action.value,
              checkTag: 'done'
            };
        }
      } else {
        return {
          ...state,
          nfcUri: action.value.nfcUri,
          nfcSchemaCompressed: action.value.nfcSchemaCompressed,
          checkTagResult: action.value,
          checkTag: 'done'
        };
      }

    case 'data/urlUpdated':
      return { ...state, nfcUri: action.value };
    case 'data/setValidError':
      return { ...state, nfcDataValidationError: action.value };
    case 'data/S/updated':
      return {
        ...state,
        nfcSchema: action.value,
      };
    case 'data/S/updatedCompressed':
      return {
        ...state,
        nfcSchemaCompressed: action.value
      };
    case 'data/source/set':
      return { ...state,
        nfcDataSource: action.value
      };
    // ## Application User Interface
    case 'app/ui/card/nfcNotAvailable':
      return { ...state, uiCardNfcNotAvailable: action.value };
    case 'app/ui/card/nfcNotGranted':
      return { ...state, uiCardNfcNotGranted: action.value };
    case 'app/ui/card/appInstallable':
      return { ...state, uiCardAppInstallable: action.value };
    case 'app/ui/card/appOpen':
      return { ...state, uiCardAppOpen: action.value };
    case 'app/ui/dialog/ndef/show':
      return { ...state, uiScanDialog: action.value };
    case 'app/ui/dialog/default/show':
      return { ...state, uiDialog: action.value };
    case 'app/ui/dialog/default/close':
      return { ...state, uiDialog: null };
    case 'app/ui/menu/dialog/default/close':
      return { ...state, uiMenuDialog: null };
    case 'app/ui/menu/dialog/goto':
      return { ...state, uiMenuDialog: action.value };
    case 'app/ui/dataPage/tab':
      return { ...state, uiDataPageTab: action.value };
    case 'app/ui/control/nfcGrantCheck':
      return {
        ...state,
        nfcGrantCheck: action.value,
      };
    case 'app/ui/control/appInstallTrigger':
      return {
        ...state,
        appInstallPromptTrigger: action.value,
      };
    case 'app/ui/dialog/error':
      return {
        ...state,
        errorTitle: action.title,
        errorText: action.text
      };
    case 'app/ui/snackbar/show':
      return { ...state,
        snackbarOpen: true,
        snackbarMessage: action.message,
        snackbarSeverity: action.severity
      };
    case 'app/ui/snackbar/close':
      return { ...state,
        snackbarOpen: false,
        snackbarMessage: null
      };
    // ### Scan Dialogue Reducers
    case 'app/ui/scanDialog/readInitializer':
      return { ...state,
        scanDialog_alertType:(action.value.changedParams === 0)?"info":"warning",
        scanDialog_alertHeadline: "Information",
        scanDialog_alertSubHeadline: "Read mode enabled",
        scanDialog_alertText: (action.value.scanTime!=="unknown" || action.value.changedParams > 0)?`Current data ${(action.value.changedParams>0)?('with '+action.value.changedParams+' change(s)'):''} will be discarded.`:"Read data from a device first.",
        scanDialog_ImageCardType:"start", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Ready to scan",
        scanDialog_ImageCardSubtext:"To scan, hold your phone close to the device.",
        scanDialog_showModeChanger:(action.value.scanTime==="unknown")?false:true,
        scanDialog_dialogBtnText:"Cancel"
      };
    case 'app/ui/scanDialog/writeInitializer':
      return { ...state,
        scanDialog_alertType: writeInitializerType(state),
        scanDialog_alertHeadline: writeInitializerHeadline(state),
        scanDialog_alertSubHeadline: writeInitializerSubHeadline(state),
        scanDialog_alertText: writeInitializerText(state, action.value),
        // scanDialog_alertText:(action.value <= 0)? "Data will be written to scanned device.":`${action.value} change(s) will be written to device.`,
        scanDialog_ImageCardType:"start", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Ready to scan",
        scanDialog_ImageCardSubtext:"To scan, hold your phone close to the device.",
        scanDialog_showModeChanger:true,
        scanDialog_dialogBtnText:"Cancel"
      };
    // Device was scanned with wrong brand value version.
    case 'app/ui/scanDialog/incompatibleDevice':
      navigator.vibrate([200, 30, 200, 30, 200]);
      return { ...state,
        scanDialog_alertType:"error",
        scanDialog_alertHeadline:`Error S01`,
        scanDialog_alertSubHeadline: "Device not compatible",
        scanDialog_alertText: "The device is not compatible with this app.",
        scanDialog_ImageCardType:"error", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Scan failed",
        scanDialog_ImageCardSubtext:"Please scan a different device.",
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Cancel"
      };
    // RE00 - General read / check error
    // RE01 - Wrong record media type
    // RE02 - Record Key unkown
    // RE03 - Empty record, tag technology or format not supported (NdefFormatable)
    // RE04 - Record type not supported
    // RE05 - Record Data invalid
    // RE06 - Record Key invalid
    case 'app/ui/scanDialog/unknownDevice':
      navigator.vibrate([200, 30, 200, 30, 200]);
      return { ...state,
        scanDialog_alertType:"error",
        scanDialog_alertHeadline:`Error S02-${action.value}`,
        scanDialog_alertSubHeadline: `Unknown or faulty device detected`,
        scanDialog_alertText: "The device is either faulty or not compatible with this app.",
        scanDialog_ImageCardType:"error", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Scan failed",
        scanDialog_ImageCardSubtext:"Please try again or scan another device.",
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Cancel"
      };
    // Sn check failed while writing
    case 'app/ui/scanDialog/writingToSameDevice':
      navigator.vibrate([200, 30, 200, 30, 200]);
      return { ...state,
        scanDialog_alertType:"error",
        scanDialog_alertHeadline:`Error S03`,
        scanDialog_alertSubHeadline: "Other device recognised by serial number",
        scanDialog_alertText: `The first read is made via no. ${action.value.src.substring(0, 5)}, but the write attempt is made on no. ${action.value.dest.substring(0, 5)}.`,
        scanDialog_ImageCardType:"error", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Write attempt blocked",
        scanDialog_ImageCardSubtext:"Read device at first before writing or activate semless writing in settings menu.",
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Cancel"
      };
    // Device type (article code) check failed while writing
    case 'app/ui/scanDialog/writingToDiffDevice':
      navigator.vibrate([200, 30, 200, 30, 200]);
      return { ...state,
        scanDialog_alertType:"error",
        scanDialog_alertHeadline:`Error S04`,
        scanDialog_alertSubHeadline:"Different device detected",
        scanDialog_alertText: `No data can be written from device ${action.value.src} to device ${action.value.dest}.`,
        scanDialog_ImageCardType:"error", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Write attempt failed",
        scanDialog_ImageCardSubtext:`Please try again with ${action.value.src} or read from device ${action.value.dest} first.`,
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Cancel"
      };
    // Schema version is different
    case 'app/ui/scanDialog/writingMajorVersChanged':
      navigator.vibrate([200, 30, 200, 30, 200]);
      return { ...state,
        scanDialog_alertType:"error",
        scanDialog_alertHeadline:`Error S05`,
        scanDialog_alertSubHeadline: "Different configuration version detected",
        scanDialog_alertText: `Version ${action.value.srcVer} of the current configuration is not compatible with target version ${action.value.destVer}. `,
        scanDialog_ImageCardType:"error", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Write attempt failed",
        scanDialog_ImageCardSubtext:"Read this device at first before writing or try another device.",
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Cancel"
      };
    // Parameter validation failed
    case 'app/ui/scanDialog/writingChangedParamValidation':
      navigator.vibrate([200, 30, 200, 30, 200]);
      return { ...state,
        scanDialog_alertType:"error",
        scanDialog_alertHeadline:`Error S06`,
        scanDialog_alertSubHeadline: "Parameter validation failed",
        scanDialog_alertText: "Writing not possible. Please check and correct the form!",
        scanDialog_ImageCardType:"error", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Scan disabled",
        scanDialog_ImageCardSubtext:"Please check the current changes for validity.",
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Cancel"
      };
    // Empty tag (no records found)
    case 'app/ui/scanDialog/emptyTag':
      navigator.vibrate([200, 30, 200, 30, 200]);
      return { ...state,
        scanDialog_alertType:"error",
        scanDialog_alertHeadline:`Error S07`,
        scanDialog_alertSubHeadline: "Empty tag found",
        scanDialog_alertText: "No data available. Please wait a moment and try again.",
        scanDialog_ImageCardType:"error", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Scan failed",
        scanDialog_ImageCardSubtext:"Please try again or use another device.",
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Cancel"
      };
    // Write error
    case 'app/ui/scanDialog/writeFailed':
      navigator.vibrate([200, 30, 200, 30, 200]);
      return { ...state,
        scanDialog_alertType:"error",
        scanDialog_alertHeadline:`Error S08`,
        scanDialog_alertSubHeadline: "Transmission error",
        scanDialog_alertText: "Writing cancelled due to incorrect or incomplete data. Maybe your device has been detached from the tag.",
        scanDialog_ImageCardType:"error", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Write attempt failed",
        scanDialog_ImageCardSubtext:"Please try again and keep device intact during scan.",
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Cancel"
      };
    // Json format error
    case 'app/ui/scanDialog/jsonParseError':
      navigator.vibrate([200, 30, 200, 30, 200]);
      return { ...state,
        scanDialog_alertType:"error",
        scanDialog_alertHeadline:`Error S09`,
        scanDialog_alertSubHeadline: "Incorrect data",
        scanDialog_alertText: "Incorrect data found. Please wait a moment and try again. ",
        scanDialog_ImageCardType:"error", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Scan failed",
        scanDialog_ImageCardSubtext:"Please try again or use another device.",
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Cancel"
      };
    // Default error
    case 'app/ui/scanDialog/unknownError':
      navigator.vibrate([200, 30, 200, 30, 200]);
      return { ...state,
        scanDialog_alertType:"error",
        scanDialog_alertHeadline:`Error S99-${action.value}`,
        scanDialog_alertSubHeadline: `Unknown error`,
        scanDialog_alertText: "An unknown scan error occurred.",
        scanDialog_ImageCardType:"error", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Scan failed",
        scanDialog_ImageCardSubtext:"Please try again or scan another device.",
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Cancel"
      };
    case 'app/ui/scanDialog/processing':
      return { ...state,
        scanDialog_alertType:"processing",
        scanDialog_alertHeadline:"Information",
        scanDialog_alertSubHeadline: "Scan in progress",
        scanDialog_alertText: "Please wait ...",
        scanDialog_ImageCardType:"progress", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Transmitting data...",
        scanDialog_ImageCardSubtext:"Please hold still while transmitting.",
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Cancel"
      };
    case 'app/ui/scanDialog/done':
      navigator.vibrate([100, 30, 100]);
      return { ...state,
        scanDialog_alertType:"success",
        scanDialog_alertHeadline:"Scan status",
        scanDialog_alertSubHeadline: "Successful",
        scanDialog_alertText: (!action.value || action.value<=0)?"Data has been updated.":`${action.value} parameter(s) has been updated on the device.`,
        scanDialog_ImageCardType:"success", //image["start", "progress", "success", "error"]
        scanDialog_ImageCardHeadline:"Scan complete",
        scanDialog_ImageCardSubtext:"Data has been successfully transmitted.",
        scanDialog_showModeChanger:false,
        scanDialog_dialogBtnText:"Done",
      };
    // ## Application User Settings
    case 'app/settings/userAuthorized':
      return {
        ...state,
        settingAuthenticated: action.value
      };
    case 'app/settings/seamlessRead/toggle':
      return {
        ...state,
        settingSeamlessRead: action.value
      };
    case 'app/settings/seamlessWrite/toggle':
      return {
        ...state,
        settingSeamlessWrite: action.value
      };
    case 'app/settings/forceWrite/toggle':
      return {
        ...state,
        settingForceWrite: action.value
      };
    // ## Application Status
    case 'app/status/online':
      return {
        ...state,
        appOnline: action.value
      };
    case 'app/status/installation/':
      return {
        ...state,
        appStatusInstallation: action.value
      };
    case 'app/status/displayMode':
      return {
        ...state,
        appStatusDisplayMode: action.value,
      };
    // ## Application Theme by Brands
    case 'app/brand/logoUrl/updated':
      return { ...state, appBrandLogoUrl: action.value };
    case 'app/brand/data/updated':
      return { ...state,
        brandName: action.brandName,
        brandTitle: action.brandTitle,
        brandColor1: action.brandColor1,
        brandColor2: action.brandColor2,
        brandOwner: action.brandOwner,
        brandStreet: action.brandStreet,
        brandZip: action.brandZip,
        brandCity: action.brandCity,
        brandMail: action.brandMail,
        brandPhone: action.brandPhone
      };
    case 'app/brand/manifest/updated':
      console.debug("Dispatch:", action.type, action.appName, action.appNameShort)
      return { ...state,
        appManifestName: action.appName,
        appManifestShortName: action.appNameShort
      };
    case 'app/env/set':
      console.debug("Dispatch:", action.type, "Value: ", action.value)
      return { ...state,
        appEnv: action.value
      };
    case 'app/env/resetToNoData':
      console.debug("Dispatch:", action.type, "Value: ", action.value)
      return {
        ...state,
        uiNdefState: 'done',
        nfcDataScanTime: 'unknown'
      };
    case 'app/sw/init':
      console.debug("Dispatch:", action.type, "Value: ", action.value)
      return {
        ...state,
        appSwInitialized: true,
      };
    case 'app/sw/update':
      console.debug("Dispatch:", action.type, "Reg: ", action.value)
      return {
        ...state,
        appSwUpdated: true,
        appSwRegistration: action.value,
      };
    default: return state;
  }
}

// Todo: Make state nested with 'immer':
// https://www.npmjs.com/package/immer

export const initialState = {
  brandName: '', //
  brandTitle: '', // Sub title
  brandColor1: '#005d9d', // Primary Color
  brandColor2: '#00796b', // Secondary Color
  brandOwner: false, // Show Product Owner Info
  brandStreet: '',
  brandZip: '',
  brandCity: '',
  brandMail: '',
  brandPhone: '',
  appManifestName: 'NFC Configuration',
  appManifestShortName: 'NFC Config',
  appBrandLogoUrl: 'image/kde/logo.png',
  appOnline: true,
  currentURL: 'undefined',
  nfcTagSn: '00:00:00:00:00:00:00:00',
  nfcUri: null,
  nfcSchemaCompressed: null, // schema from device
  nfcSchema: {}, // unzipped or imported schema
  nfcDataValidationError: false,
  nfcDataScanTime: 'unknown',
  nfcDataSource: 'unknown', // [import, scan, app]
  // changed or imported values:
  // TODO(Hoffmannm): set default for nfcData and/or origin?
  nfcDataV: {"V": {}},
  nfcDataVP: {"VP": {}},
  nfcDataCP: {"CP": {}},
  nfcDataP: {"P": {}},
  nfcDataPR: {"PR": {}},
  nfcDataPP: {"PP": {}},
  // inital laoded values without changes:
  originP: {"P": {}},
  originPR: {"PR": {}},
  originPP: {"PP": {}},
  checkTag: 'pending', // pending, done
  checkTagResult: {},
  nfcAvailable: false,
  nfcPermission: 'prompt', // [granted, denied, prompt]
  nfcGrantCheck: false,
  appInstallPromptTrigger: false,
  appStatusDisplayMode: 'undefined', // [browser, pwa, undefined]
  appStatusInstallation: 'undefined', // [undefined, uninstalled, progress, installed] Keeps record on if app is installed or not
  uiCardNfcNotAvailable: 'show',
  uiCardNfcNotGranted: 'hide',
  uiCardAppInstallable: 'hide',
  uiCardAppOpen: 'hide',
  uiDialog: null, // [share, devmode, import]
  uiMenuDialog: null, // [settings, about, help]
  uiDataPageTab: 0, // 0 = values, 1 = parameters
  uiScanDialog: false, // Show scanDialog or not´
  uiImportConfigName: 'unkown',
  ndefControl: 'idle', // [idle, reading, writing]
  uiNdefState: 'done', // [done, scanning, error, ...]
  writeLock: false,
  errorTitle: null,
  errorText: null,
  snackbarOpen: false,
  snackbarMessage: null,
  snackbarSeverity:'info', // success, info, warning, error
  settingAuthenticated: false,
  settingSeamlessRead: false, // [state to handle seamless read]
  settingSeamlessWrite: false, // [state to handle seamless write]
  settingForceWrite: false, // [state to handle seamless write]
  appEnv:'prd',
  // Service Worker
  appSwInitialized: false,
  appSwUpdated: false,
  appSwRegistration: null,
  //Dialogue States
  scanDialog_alertType:"", //alert type ["error", "info", "success", "warning", "processing"]
  scanDialog_alertHeadline:"",
  scanDialog_alertSubHeadline:"",
  scanDialog_alertText:"",

  scanDialog_ImageCardType:"", //image["start", "progress", "success", "error"]
  scanDialog_ImageCardHeadline:"No headline loaded",
  scanDialog_ImageCardSubtext:"No subtext loaded",

  scanDialog_showModeChanger:true,
  scanDialog_dialogBtnText:"Cancel",
};
